import { Injectable } from '@angular/core';
import { UnitOfWorkBase, UnitOfWorkHelper } from '../services';
import { NotificationsEntityManagerProvider } from './notifications-entity-manager-provider';

@Injectable({ providedIn: 'root' })
export class NotificationsUnitOfWork extends UnitOfWorkBase {
  constructor(entityManagerProvider: NotificationsEntityManagerProvider, helper: UnitOfWorkHelper) {
    super(entityManagerProvider, helper);
  }
}
